/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import { Grid, TextField } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  getPlanTypeValues,
  getRebateProgrameList,
  getNDCPaymentMaxQuarter,
  setSearchInput,
  getNDCPaymentResultGrid,
  setNdcPaymentData,
} from '../Store/actions';
import {
  quarterToDate,
  convertStringDate,
  convertToFourDigitYear,
  validateQuarter,
} from '../../../../SharedModules/utilities/utilities';

import { REBATE_SELECT } from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';
import { handleScrollToEvent } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export default function ReqNDCPayment(props) {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    // selectedPlanType,
    // rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    manufacturerList: resultanufacturerList,
    ndcPaymentMaxQuarter,
    // quarterValue,
    searchResult,
    searchScreenVar: { rebateProgramValue, selectedPlanType, quarterValue },
  } = useSelector((state) => state?.sharedState?.NDCPaymentReducer);

  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );
  const [radioList, setRadioList] = React.useState([]);
  const [planType, setPlanType] = React.useState(selectedPlanType);
  const [selectList, setSelectList] = React.useState([]);
  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);
  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );
  const [errorList, setErrorList] = useState(errors);
  const [quarter, setQuarter] = useState(quarterValue);
  const [maxQtr, setMaxQtr] = React.useState([]);
  const [isSearchClicked, setSearchClicked] = useState(false);

  // For No Data validation
  React.useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    handleScrollToEvent();
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList?.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  React.useEffect(() => {
    dispatch(getNDCPaymentMaxQuarter());
  }, []);

  React.useEffect(() => {
    if (ndcPaymentMaxQuarter) {
      setQuarter(quarterValue || ndcPaymentMaxQuarter?.maxQuarterVO);
    }
  }, [ndcPaymentMaxQuarter]);
        
    //remove no data error msg
    React.useEffect(() => {
      dispatch(setSearchInput({ errors: [] }));
    }, [planType, planTypeList, rebateProgram, quarter, ]);

  // function to conver 2 digit year to 4 digit ear
  const convertTo4DigitQtr = (value) => {
    const tempValue = value.split('Q');

    tempValue.splice(1, 1, convertToFourDigitYear(tempValue[1]));
    return tempValue.join('Q');
  };

  // Handle onblur events for date and quarter
  const handleOnBlur = (type, value) => {
    let localErrors = errorList;
    if (type === 'qtr') {
      localErrors = localErrors.filter((error) => error.field != 'qtr');
      const qtrErr = validateQuarter(value, 'qtr', true);
      if (qtrErr.length === 0) {
        const qtr = value.length == 4 ? convertTo4DigitQtr(value) : value;
        setQuarter(qtr);
      } else {
        localErrors = [...localErrors, ...qtrErr];
      }
    }
    setErrorList(localErrors);
  };

  const handleSearchClick = () => {
    let allErrors = [];
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    allErrors = [...errorList, ...allErrors];

    setErrorList(allErrors);
    if (allErrors.length === 0) {
      dispatch(setNdcPaymentData([]));
      setSearchClicked(true);
      // Variable to get fullname of rebate program from rebate program list(selectList)
      let rebateProgrameName =
        selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
      rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
        rebateProgrameName?.shortDescr || ''
      }`;
      dispatch(
        setSearchInput({
          errors: allErrors,
          selectedPlanType: planType,
          rebateProgramValue: rebateProgram,
          rebateProgramName,
          rebateProgrameName,
          quarterValue: quarter,
          searchScreenVar: {
            rebateProgrameName,
            rebateProgramValue: rebateProgram,
            selectedPlanType: planType,
            quarterValue: quarter,
          },
        })
      );
      dispatch(
        getNDCPaymentResultGrid({
          startDate: convertStringDate(quarterToDate(quarter)),
          endDate: convertStringDate(quarterToDate(quarter, 'toDate')),
          rebateProgram: rebateProgram,
          quarter: quarter,
        })
      );
    }
  };

  if (isSearchClicked && searchResult && searchResult.length > 0) {
    setSearchClicked(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/dispNDCPayment',
      value: 'Display NDC Payment',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
    if (props?.history) {
      props.history.push({
        pathname: '/dispNDCPayment',
      });
    }
    dispatch(clearReduxForFilterAndSort('/dispNDCPayment'));
  }
  const errorMessages = [...new Set(errorList.map((obj) => obj.message))];
  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />
      <CustomSeparator parent1="State Reports" parent2="NDC Payment" />
      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />
      <div className="tab-body">
        <div className="row">
          <div className="col-4 frr-two-col-radio">
            <RadioGroupComponent
              data-testid="req-NDC-Payment-plan-type"
              id="filter-plan-by-radio-btn-action"
              labelName="Plan Type"
              required={false}
              optionList={radioList || []}
              defaultValue={planType}
              filterAction={(value) => {
                setPlanType(value);
                setRebateProgram('-1');

                const errors = errorList.filter(
                  (error) => error.field !== 'rebateProgram'
                );
                setErrorList([...errors]);
              }}
              className="log-batch-filter-radio frr-checkInvoiceRadio"
            />
          </div>
          <div className="col-4">
            <>
              <Fieldset label="Rebate Program" required>
                <div>
                  <SelectBoxComponent
                    data-testid="req-NDC-Payment-rebate-program"
                    id="filter-plan-by-radio-btn-action"
                    labelName="Rebate Program"
                    required
                    select
                    selectOne
                    optionList={selectList || []}
                    defaultValue={rebateProgram}
                    filterAction={(value) => {
                      setRebateProgram(value);
                      setRebateProgramName(value);
                      const errors = errorList.filter(
                        (error) => error.field !== 'rebateProgram'
                      );
                      setErrorList([...errors]);
                    }}
                    isError={
                      errorList.find((error) => error.field === 'rebateProgram')
                        ?.message
                    }
                  />
                </div>
              </Fieldset>
            </>
          </div>

          <div className="col-3 mt-2">
            <div className="mui-custom-form input-md field-xl">
              <TextField
                label="Quarter"
                id="quarterreq"
                data-testid="req-NDC-payment-quarter"
                placeholder=""
                InputLabelProps={{
                  shrink: true,
                }}
                inputProps={{ maxLength: 6, id: 'quarterreq' }}
                required
                name="From"
                value={quarter}
                error={
                  errorList.filter((error) => error.field === 'qtr')?.length > 0
                    ? 'mandate-fields'
                    : ''
                }
                helperText={
                  errorList.find((error) => error.field === 'qtr')?.message
                }
                className="mandate-fields"
                onBlur={(e) => handleOnBlur('qtr', e.target.value)}
                onChange={(e) => {
                  const { value } = e.target;
                  setQuarter(value.toUpperCase());
                  const localErrors = errorList.filter(
                    (error) => error.field != 'qtr'
                  );
                  setErrorList(localErrors);
                }}
              />
            </div>
          </div>
        </div>
        <div className="row" style={{ marginTop: 15 }}>
          <div className="btn-wrapper col-12">
            <Button
              data-tesid="view_detail_ia"
              onClick={handleSearchClick}
              className="btn btn-success btn-search float-right"
            >
              <SVGComponent iconName="Icon-search" /> Search
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
